import { useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import routes from "./routes";
import { useSetRecoilState } from "recoil";
import ZJSBridge from "zalo-js-bridge";
import { zoomState } from "state";

function App() {
  const setZoom = useSetRecoilState(zoomState);
  useEffect(() => {
    if (window && window.innerHeight < 640) {
      setZoom(window.innerHeight / 640);
    }
    ZJSBridge.H5.configRightMenu([], 0, 0, () => { }, () => { });
  }, []);

  return (
    <Router>
      <Routes>
        {routes.map((route) => (
          <Route {...route} />
        ))}
      </Routes>
    </Router>
  );
}

export default App;
